export default {
  siteName: 'banav',
  additionalInfo: {
    phone: '(51) 9 2001-5207',
    email: 'contato@angelpassagens.com'
  },
  headerConfig: {
    height: '68px',
    backgroundColor: 'white'
  }
}